module.exports = __webpack_public_path__ + "static/alternative_education-81e1e5d754401c44ae7ba3543bd336db.jpg";